import { render, staticRenderFns } from "./indexfooter.vue?vue&type=template&id=7a25a3cb&scoped=true&"
import script from "./indexfooter.vue?vue&type=script&lang=js&"
export * from "./indexfooter.vue?vue&type=script&lang=js&"
import style0 from "./indexfooter.vue?vue&type=style&index=0&id=7a25a3cb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a25a3cb",
  null
  
)

export default component.exports